import React from 'react';
import { graphql } from 'gatsby';
import IndexTemplate from 'templates/home';
import { useTranslation } from 'react-i18next';

const IndexPage = props =>{
  const [t] = useTranslation();
  return (
    <IndexTemplate
      {...props}
      seoTitle={t('page--home.seoTitle')}
      seoDescription={t('page--home.seoDescription')}
    />
  )
};
export default IndexPage;

// export const query = graphql`
//   query IndexPage($slug: String) {
//     strapiPages(slug: { eq: $slug }) {
//       id
//       jsonData {
//         title
//         header {
//           title
//           subtitle
//         }
//       }
//       seoTitle
//       seoDescription
//     }
//     allStrapiInformational {
//       nodes {
//         id
//         title
//         content
//         imageAlt
//         image {
//           childImageSharp {
//             fluid(maxHeight: 640, quality: 90) {
//               ...GatsbyImageSharpFluid_withWebp
//             }
//           }
//         }
//       }
//     }
//   }
// `;
